module.exports = __webpack_public_path__ + "img/volcan.57f5ab15.svg";